var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHow2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "145px",
    viewBox: "10 -15 130 145",
    enableBackground: "new 10 -15 130 145",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAF1EF",
    d: "M107.068,80.097c-15.785-1.125-27.445-12.853-37.618-23.777c-3.93-4.22-8.743-7.581-13.784-10.34 c-5.724-3.131-11.893-5.491-18.28-6.853c-8.398-1.791-17.435-1.619-24.982,1.968c-1.073,4.665-1.641,9.522-1.641,14.513 c0,35.608,28.866,64.473,64.474,64.473c29.362,0,54.136-19.629,61.925-46.479C127.743,77.96,117.302,80.825,107.068,80.097z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAF1EF",
    d: "M39.952,37.095c11.603,2.859,23.393,8.827,31.563,17.695c9.981,10.835,21.747,22.481,37.447,22.839 c9.972,0.228,19.986-2.772,29.042-7.233c1.114-4.749,1.706-9.7,1.706-14.788c0-35.607-28.865-64.473-64.473-64.473 c-29.458,0-54.302,19.757-62.004,46.743C21.574,34.601,31.235,34.948,39.952,37.095z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M96.438,44.764l-1.596-0.842c-0.302-0.159-0.674-0.013-0.785,0.31l0,0 c-0.088,0.251,0.015,0.53,0.244,0.665l1.561,0.911c0.275,0.159,0.627,0.058,0.774-0.225l0.036-0.068 C96.813,45.243,96.709,44.907,96.438,44.764z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#233D5F",
    points: "112.167,83.231 113.061,84.721 116.339,82.346 115.089,81.193  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#010060",
    cx: 31.303,
    cy: 102.102,
    r: 16.518
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 31.303,
    cy: 102.102,
    r: 8.718
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#010060",
    cx: 31.303,
    cy: 102.102,
    r: 2.755
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#010060",
    cx: 123.444,
    cy: 102.36,
    r: 16.519
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 123.444,
    cy: 102.36,
    r: 8.718
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#010060",
    cx: 123.445,
    cy: 102.36,
    r: 2.755
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M117.353,78.666c-0.003,0.87-0.506,1.657-1.293,2.027c-5.264,2.475-8.44,7.693-8.44,7.693 c-7.577,15.584-10.248,13.657-12.597,14.82c-2.041,1.015-35.34,0.589-43.952,0.46c-0.95-0.014-1.569-1.002-1.169-1.863 l1.114-2.402l-40.673-0.113c1.248-6.262,3.856-11.346,6.858-15.379c1.644-2.208,3.405-4.104,5.125-5.702 c5.204-4.84,10.023-6.976,10.023-6.976l37.996-0.563c0.163-0.013,0.312-0.013,0.447,0c0.084,0.007,0.165,0.019,0.239,0.033 c0.017,0.004,0.035,0.007,0.051,0.01c1.226,0.285,1.098,1.636,1.098,1.636s-7.551,7.008-8.225,14.874 c-0.008,0.109-0.017,0.219-0.024,0.325c-0.332,5.482,3.962,10.146,9.446,10.425c5.891,0.3,17.903,0.704,20.66-0.79 c1.568-0.852,2.743-1.521,3.912-2.629c0,0,0,0,0.002-0.002c0.9-0.852,1.798-1.965,2.869-3.62 c0.806-1.243,1.709-2.793,2.788-4.77c3.71-6.805,2.478-11.815,1.614-15.122c-0.152-0.592-0.297-1.129-0.396-1.612 c-0.07-0.337-0.244-0.82-0.498-1.42c-1.396-3.3-5.206-10.116-7.422-15.23c-0.007-0.011-0.013-0.022-0.016-0.034 c-0.222-0.515-0.427-1.009-0.609-1.481c-0.005-0.015-0.012-0.029-0.017-0.041c-0.023-0.057-0.034-0.084-0.034-0.084 c-0.604-1.558-0.98-2.863-0.979-3.718c0-0.243,0.032-0.449,0.098-0.613c1.179-3.012,2.52-3.174,2.52-3.174l4.661,8.55 l11.155,20.953C118.868,75.824,117.353,78.666,117.353,78.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M136.529,90.767c-3.664,0.267-9.304-0.103-12.184,1.477c-4.861,2.664-10.237,10.014-20.277,8.479 c0,0,2.716-12.88,12.271-18.377c9.556-5.496,21.25,2.147,23.415,6.131C140.636,90.1,139.049,90.582,136.529,90.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01005F",
    d: "M73.089,68.756l-0.003,0.012c-0.234,1.113-1.206,1.919-2.342,1.94l-39.805,0.805 c-0.49,0.01-0.957-0.126-1.349-0.375c-0.153-0.094-0.295-0.208-0.421-0.336c-0.308-0.302-0.536-0.69-0.647-1.131l-0.235-0.928 c-0.394-1.548,0.778-3.048,2.374-3.044l40.044,0.112C72.252,65.815,73.407,67.24,73.089,68.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M51.015,99.401l-40.673-0.113c0,0,6.143-22.222,25.186-21.753c0.434,0.011,0.875,0.032,1.321,0.067 C56.929,79.167,51.015,99.401,51.015,99.401z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M97.003,48.251l-4.861,3.221c-0.422,0.279-0.533,0.85-0.246,1.267l0,0 c0.271,0.392,0.796,0.508,1.204,0.267l5.035-2.967c0.451-0.266,0.583-0.858,0.287-1.29l-0.173-0.254 C97.97,48.087,97.415,47.978,97.003,48.251z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBAF53",
    d: "M103.423,52.068c-0.181,0.09-0.387,0.141-0.607,0.141l-1.447-0.004c0,0-2.876-1.647-2.34-6.426 l1.303-0.865c0.133-0.087,0.273-0.149,0.417-0.185c0.659-0.17,1.381,0.177,1.631,0.862l1.729,4.78 C104.356,51.058,104.022,51.774,103.423,52.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M103.423,52.068c-1.048-4.858-2.68-7.338-2.68-7.338l0.005-0.002c0.659-0.17,1.381,0.177,1.631,0.862 l1.729,4.78C104.356,51.058,104.022,51.774,103.423,52.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233D5F",
    d: "M22.325,78.207c-1.72,1.598-3.481,3.494-5.125,5.702l0,0c-0.993-0.003-1.571-1.125-0.997-1.936 l2.311-3.257c0.231-0.325,0.605-0.519,1.003-0.517L22.325,78.207z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#233D5F",
    d: "M71.03,70.701l-0.287,0.007c0,0,0.018-0.017,0.048-0.04 c0.121-0.099,0.417-0.316,0.295,0.032L71.03,70.701z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M10.684,99.393L10,99.182c0.015-0.05,1.548-4.941,4.665-9.975c4.151-6.705,9.222-10.624,14.662-11.335 c9.041-1.18,15.177,0.032,18.759,3.708c3.48,3.57,4.585,9.586,3.283,17.877l-0.708-0.111c1.265-8.056,0.226-13.865-3.088-17.266 c-3.414-3.503-9.351-4.646-18.153-3.497c-6.594,0.861-11.332,6.457-14.146,11.001C12.205,94.54,10.699,99.346,10.684,99.393z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.635,
    y: 87.054,
    transform: "matrix(1 0.0028 -0.0028 1 0.2414 -0.1083)",
    fill: "#010060",
    width: 13.448,
    height: 0.717
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.626,
    y: 90.107,
    transform: "matrix(1 0.0028 -0.0028 1 0.2564 -0.1111)",
    fill: "#010060",
    width: 13.448,
    height: 0.716
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.618,
    y: 93.159,
    transform: "matrix(1 0.0028 -0.0028 1 0.265 -0.111)",
    fill: "#010060",
    width: 13.448,
    height: 0.717
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M71.082,70.711c-1.225,1.125-2.409,2.288-3.547,3.493c-1.143,1.2-2.231,2.448-3.25,3.746 c-0.504,0.651-0.989,1.316-1.449,1.997c-0.454,0.684-0.876,1.386-1.25,2.11c-0.745,1.446-1.303,2.995-1.255,4.593 c0.005,1.634,0.135,3.285,0.68,4.79c0.269,0.749,0.645,1.458,1.157,2.063c0.506,0.608,1.123,1.128,1.81,1.552 c0.684,0.427,1.43,0.766,2.194,1.062c0.765,0.294,1.555,0.537,2.351,0.755c1.596,0.438,3.225,0.766,4.854,1.099 c-1.654-0.176-3.303-0.411-4.938-0.757c-1.626-0.363-3.263-0.824-4.75-1.681c-0.189-0.1-0.363-0.225-0.546-0.338 c-0.177-0.122-0.35-0.251-0.521-0.383l-0.247-0.21c-0.083-0.069-0.162-0.143-0.238-0.22l-0.232-0.229l-0.216-0.244 c-0.577-0.654-1.007-1.428-1.314-2.233c-0.309-0.809-0.488-1.652-0.601-2.493c-0.111-0.843-0.153-1.688-0.159-2.529l-0.001-0.315 l0.019-0.327l0.02-0.329l0.049-0.323l0.05-0.323c0.02-0.106,0.049-0.21,0.073-0.314c0.05-0.212,0.097-0.423,0.167-0.625 c0.253-0.821,0.589-1.609,0.995-2.353c0.403-0.745,0.854-1.457,1.332-2.149c0.482-0.688,0.998-1.351,1.533-1.994 c1.072-1.286,2.228-2.493,3.436-3.643C68.5,72.814,69.754,71.716,71.082,70.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M98.708,98.282l-0.53-0.482c10.429-11.47,10.497-21.971,8.718-28.761 c-1.934-7.375-6.399-12.104-6.444-12.151l0.518-0.495c0.045,0.047,4.625,4.89,6.611,12.435c1.169,4.437,1.229,8.929,0.181,13.352 C106.453,87.696,103.407,93.114,98.708,98.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M137.113,88.963c-2.808-3.286-6.388-5.031-10.642-5.188c-3.19-0.12-5.583,0.752-5.607,0.762l-0.249-0.672 c0.102-0.037,2.528-0.925,5.854-0.806c3.076,0.108,7.514,1.14,11.188,5.438L137.113,88.963z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M133.845,111.981l-0.52-0.563c2.949-2.722,4.448-5.705,4.46-8.867c0.019-5.405-4.364-9.568-4.409-9.608 l0.524-0.561c0.19,0.178,4.667,4.423,4.652,10.165C138.542,105.933,136.959,109.107,133.845,111.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.137,117.116l-0.24-0.729c0.117-0.039,11.732-4.005,11.763-14.926l0.767,0.001 C46.395,112.943,34.259,117.076,34.137,117.116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M72.242,8.589c0,0,0.82-0.82,1.203-2.323c0.101-0.387,0.17-0.821,0.189-1.298 c0.093-2.323,8.545-1.857,8.545-1.857s0.279,4.458,1.764,5.478C85.43,9.611,75.492,15.276,72.242,8.589z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M81.011,118.505c0,0,0.015-7.146-0.321-8.589c-0.339-1.441,5.033,0.852,5.033,0.852 s0.043,7.107,0.5,8.561C86.223,119.328,82.506,118.319,81.011,118.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M87.869,127.328c-0.557,1.95-5.85,1.462-6.547,0.418c-0.33-0.494-0.643-2.028-0.808-3.724 c-0.001-0.006-0.001-0.011-0.003-0.016c-0.011-0.115-0.022-0.23-0.031-0.346c0-0.009-0.002-0.015-0.002-0.021v-0.017 c-0.148-1.781-0.127-3.663,0.216-4.655c0,0-0.067-1.811,1.742-1.74c1.811,0.07,3.135-0.003,3.413,0.869 c0.278,0.871,0.836,1.359,0.836,1.638c0,0.182,0.737,2.516,1.1,4.662c0,0.002,0,0.002,0,0.003 C87.979,125.552,88.064,126.647,87.869,127.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M87.869,127.328c-0.557,1.95-5.85,1.462-6.547,0.418c-0.33-0.494-0.643-2.028-0.808-3.724 c0.104,0.848,0.511,2.801,2.062,3.306c1.996,0.649,4.938,0.787,5.209-2.928C87.979,125.552,88.064,126.647,87.869,127.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M85.842,121.137c-2.255-0.663-4.369-0.009-4.389-0.002l-0.168-0.523c0.093-0.029,2.29-0.715,4.712-0.002 L85.842,121.137z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M85.932,122.471c-2.255-0.663-4.369-0.009-4.391-0.002l-0.166-0.523 c0.092-0.029,2.289-0.714,4.711-0.002L85.932,122.471z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.068,123.958c-2.254-0.662-4.369-0.008-4.389-0.001l-0.168-0.524 c0.094-0.028,2.291-0.713,4.713-0.002L86.068,123.958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M87.688,125.069c-3.573-1.321-6.998-0.014-7.032,0l-0.051-0.128c0.034-0.014,3.507-1.341,7.131,0 L87.688,125.069z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M63.465,116.53c0,0,1.114-3.621,0.696-7.452c-0.418-3.832,4.527-1.533,5.154-1.254 c0.627,0.277-0.279,8.219,0,9.96C69.595,119.526,63.813,118.759,63.465,116.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M69.966,117.715v2.223c0,1.004,0,1.957,0,1.957s-6.409,2.507-7.987,2.692 c-1.58,0.186-5.759,1.951-7.987-0.464c0,0,0.023-0.53,0.195-1.162c0.164-0.607,0.466-1.308,1.013-1.717 c1.114-0.836,6.851-4.382,7.335-5.015c1.069-1.394,3.438-0.651,3.623,0c0.186,0.649,1.208,1.113,1.951,0.649 C68.853,116.415,69.966,117.158,69.966,117.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M69.966,119.938c0,1.004,0,1.957,0,1.957s-6.409,2.507-7.987,2.692c-1.58,0.186-5.759,1.951-7.987-0.464 c0,0,0.023-0.53,0.195-1.162c0.713,0.587,2.081,1.39,4.03,1.115C60.718,123.724,67.786,120.843,69.966,119.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M60.574,121.479c-1.636-1.15-3.042-1.554-3.345-1.596L58,119.381c0.068,0.012,1.208,0.298,2.97,1.536 L60.574,121.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.115,120.224c-2.209-1.458-3.038-1.537-3.06-1.531c0,0,0.69-0.394,0.731-0.479 c0,0,1.027,0.329,2.707,1.438L62.115,120.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M63.574,119.051c-0.877-1.045-2.966-1.372-2.983-1.375l0.638-0.435c0.082,0.012,1.823,0.12,2.871,1.367 L63.574,119.051z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M59.494,123.8c-0.862-2.59-3.752-2.849-3.782-2.851l0.011-0.137c0.03,0.002,3.01,0.266,3.901,2.945 L59.494,123.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8AA50",
    d: "M62.955,54.748l-0.975,27.835l0.975,29.465c0,0,3.064,2.953,8.637,0l1.811-28.763l2.646-16.676 l0.559,16.676l2.672,29.364c0,0,1.924,2.621,8.473,0l-0.14-29.929l2.647-27.973H62.955z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M62.955,54.748c0,0,18.389,3.9,27.305,0c0,0-0.366-25.079,0.471-28.631l2.385,3.067 c0,0,7.522-0.766,7.522-3.761c0,0-3.971-11.284-8.358-14.418l-8.707-3.529c0,0-3.9,3.715-7.337,2.601 c-3.437-1.115-3.622-2.229-3.622-2.229s-9.009,3.065-10.124,4.644c-1.115,1.579-4.568,12.445-4.568,12.445 s0.156,2.925,6.564,3.901L62.955,54.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M83.387-1.534c-0.836,2.415-1.207,4.645-1.207,4.645c-0.203,0.941-1.381,1.71-2.9,2.123 c-1.75,0.477-3.953,0.48-5.645-0.266c-0.421-0.185-0.787-0.512-1.102-0.949c-2.043-2.828-1.958-10.24-1.313-13.54 c0.743-3.809,4.458-4.179,6.948-4.085c2.488,0.092,5.311,2.507,5.927,4.549C84.709-7.012,84.222-3.949,83.387-1.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8AA50",
    d: "M70.199-8.963c0,0-0.557-4.655,5.944-5.479c3.687-0.467,6.523,1.486,7.952,4.272 c1.428,2.786,0.686,4.83,0.686,4.83l-5.501-0.836C79.279-6.177,77.129-9.149,70.199-8.963z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.378,
    y: 24.083,
    fill: "#FFFFFF",
    width: 30.926,
    height: 22.289
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M81.689,46.755H49.995V23.699h31.694V46.755z M50.762,45.988h30.161V24.466H50.762V45.988z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 27.219,
    fill: "#010060",
    width: 30.925,
    height: 0.413
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 30.455,
    fill: "#010060",
    width: 30.925,
    height: 0.412
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 33.69,
    fill: "#010060",
    width: 30.925,
    height: 0.412
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 36.924,
    fill: "#010060",
    width: 30.925,
    height: 0.413
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 40.16,
    fill: "#010060",
    width: 30.925,
    height: 0.411
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.379,
    y: 43.395,
    fill: "#010060",
    width: 30.925,
    height: 0.412
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "81.307,24.083 83.999,23.432 83.999,44.329 81.307,46.372  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010060",
    d: "M80.923,47.144V23.78l3.46-0.835v21.574L80.923,47.144z M81.689,24.384V45.6l1.926-1.461V23.919 L81.689,24.384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.307,27.425l2.692-1.021L81.307,27.425z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.269,
    y: 25.475,
    transform: "matrix(0.3551 0.9348 -0.9348 0.3551 78.464 -59.9089)",
    fill: "#010060",
    width: 0.767,
    height: 2.881
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.307,30.572l2.692-1.021L81.307,30.572z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.269,
    y: 28.621,
    transform: "matrix(0.3551 0.9348 -0.9348 0.3551 81.4054 -57.8797)",
    fill: "#010060",
    width: 0.767,
    height: 2.881
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.307,33.855l2.692-1.021L81.307,33.855z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.269,
    y: 31.904,
    transform: "matrix(0.3553 0.9347 -0.9347 0.3553 84.4547 -55.7626)",
    fill: "#010060",
    width: 0.767,
    height: 2.881
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.307,37.14l2.692-1.021L81.307,37.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.27,
    y: 35.188,
    transform: "matrix(0.3557 0.9346 -0.9346 0.3557 87.4832 -53.6478)",
    fill: "#010060",
    width: 0.766,
    height: 2.881
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.307,40.286l2.692-1.349L81.307,40.286z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.269,
    y: 38.105,
    transform: "matrix(0.4482 0.8939 -0.8939 0.4482 81.0144 -52.0285)",
    fill: "#010060",
    width: 0.767,
    height: 3.012
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.307,43.569l2.692-1.568L81.307,43.569z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.269,
    y: 41.227,
    transform: "matrix(0.5031 0.8642 -0.8642 0.5031 78.0446 -50.1707)",
    fill: "#010060",
    width: 0.767,
    height: 3.117
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M93.284,29.028l1.625,3.003l-9.511,2.773l0.155,3.631c0,0,9.31-0.271,10.888-0.641 c1.579-0.373,6.595-0.465,6.966-2.136c0.372-1.672-3.014-9.2-3.014-9.2S96.019,28.487,93.284,29.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8AA50",
    d: "M92.21,28.02c0,0,6.725-2.143,7.925-3.937l1.2,2.321c0,0-1.394,2.445-8.081,3.658L92.21,28.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M79.279,5.233c-0.855,1.473-5.834,1.033-5.834,1.033c0.101-0.387,0.17-0.821,0.189-1.298 C75.326,5.714,77.529,5.71,79.279,5.233z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M79.279-6.177c0,0-1.188-2.415-3.601-2.879c-1.258-0.242-2.695-0.357-3.784-0.414l0,0l0,0 c-1.001-0.051-1.708-0.051-1.708-0.051s-2.774-0.464-3.424,0.836c-0.65,1.3,0,1.764,0,1.764l0,0h4.137 c0.397-1.015,1.356-1.705,2.446-1.74c0.122-0.004,0.25-0.004,0.384-0.003C76.799-7.931,79.279-6.177,79.279-6.177z M66.762-6.92 c0,0-0.023-0.229,0.129-0.534C66.828-7.29,66.782-7.113,66.762-6.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M82.584-5.665c-0.001-6.278-5.139-8.616-5.502-8.773c-2.767,0.675-3.561,5.046-3.569,5.09l-0.135-0.023 c0.007-0.045,0.821-4.527,3.694-5.206l0.021-0.005l0.021,0.008c0.056,0.022,5.606,2.339,5.606,8.909H82.584z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.957,
    y: -15,
    fill: "#06065C",
    width: 1.635,
    height: 0.736
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M73.401-0.226c-0.163,0-0.352-0.033-0.554-0.132c-0.597-0.29,0.34-3.126,0.534-3.691l0.13,0.044 c-0.434,1.265-0.981,3.34-0.604,3.523c0.533,0.26,0.967,0.006,0.972,0.003l0.07,0.118C73.936-0.352,73.719-0.226,73.401-0.226z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E54750",
    d: "M77.582,1.464c1.203,0,2.356-1.058,2.301-2.301c-0.055-1.247-1.011-2.301-2.301-2.301 c-1.203,0-2.356,1.058-2.301,2.301C75.337,0.41,76.292,1.464,77.582,1.464L77.582,1.464z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M76.01,67.062c-1.825-1.264-1.005-6.73-0.969-6.963l0.135,0.021c-0.008,0.057-0.842,5.614,0.912,6.828 L76.01,67.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M87.068,63.723c-3.825-2.941-3.293-5.173-3.268-5.266l0.396,0.104l-0.198-0.052l0.2,0.051 c-0.004,0.02-0.463,2.08,3.12,4.834L87.068,63.723z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "86.737,112.284 85.514,85.272 87.963,65.467 88.098,65.482 85.65,85.277 86.874,112.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "70.545,112.284 70.409,112.278 71.663,85.949 73.892,66.998 74.028,67.016 71.799,85.961  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M79.609,57.684c-7.299,0-14.879-1.118-14.994-1.135l0.021-0.135c0.171,0.025,17.208,2.538,24.765,0.001 l0.044,0.13C86.901,57.398,83.291,57.684,79.609,57.684z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M55.138,32.789c-0.174-0.643-3.184-0.231-3.184-0.231l-1.77-0.128v-1.272 c-2.136,1.439-1.533,2.6-1.625,3.892c-0.093,1.292,0.84,1.608,0.84,1.608l2.239,0.163c0,0,2.452-0.344,2.307-0.782 c-0.038-0.117-0.238-0.184-0.508-0.22c0.756-0.171,1.537-0.417,1.444-0.695c-0.083-0.25-0.777-0.312-1.483-0.309 c0.767-0.171,1.577-0.421,1.483-0.704c-0.096-0.292-1.029-0.327-1.839-0.301C53.94,33.599,55.253,33.215,55.138,32.789z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8AA50",
    points: "79.809,24.083 75.936,24.083 76.915,12.384 78.726,12.384  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.633,
    y: 21.198,
    fill: "#E8AA50",
    width: 6.219,
    height: 1.462
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "77.582,11.13 79.279,8.135 80.328,11.802 83.572,7.475 82.543,5.648 78.809,7.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "77.582,11.13 77.178,7.817 73.118,6.288 71.538,8.135 75.504,10.297 76.441,8.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8AA50",
    points: "75.956,9.538 76.914,12.384 78.726,12.384 79.68,9.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8AA50",
    points: "78.484,9.538 79.279,8.135 79.68,9.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8AA50",
    points: "76.826,9.538 76.441,8.725 75.956,9.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "80.3,11.954 79.705,9.877 79.838,9.839 80.355,11.65 83.518,7.434 83.627,7.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "75.529,10.39 71.604,8.25 71.669,8.129 75.479,10.206 76.383,8.69 76.5,8.76  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M90.415,30.312l-2.612-10.293l2.997,6.085L90.415,30.312z M88.258,21.254l2.094,8.247l0.308-3.371 L88.258,21.254z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M78.031,54.266c-6.875,0-13.319-1.045-13.416-1.062l0.022-0.135c0.146,0.023,14.684,2.383,23.374-0.014 l0.037,0.133C85.113,53.997,81.517,54.266,78.031,54.266z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#06065C",
    points: "94.857,31.978 98.507,33.345 94.364,30.661  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06065C",
    d: "M99.103,36.89c-0.024,0-0.038,0-0.04,0l0.004-0.137c0.026,0.001,2.368,0.057,3.188-1.556 c0.816-1.607-0.624-3.155-0.638-3.17l0.099-0.095c0.016,0.016,1.522,1.633,0.661,3.328C101.579,36.83,99.422,36.89,99.103,36.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A7A0",
    d: "M85.398,34.804c0,0-1.824-0.411-3.465-0.428l0.003-0.001c0,0-2.554-0.259-2.833,0 c-0.214,0.2,0.351,0.386,0.623,0.461c-0.021,0.016-0.041,0.032-0.059,0.049l-1.176,0.085c0,0-3.009-0.412-3.184,0.23 c-0.115,0.426,1.197,0.81,2.095,1.022c-0.81-0.026-1.743,0.01-1.839,0.301c-0.094,0.283,0.716,0.533,1.483,0.704 c-0.706-0.003-1.401,0.058-1.483,0.308c-0.092,0.277,0.689,0.524,1.445,0.695c-0.271,0.036-0.471,0.103-0.51,0.22 c-0.145,0.438,2.308,0.782,2.308,0.782l1.587-0.115c0.162,0.072,0.348,0.111,0.557,0.111c3.621,0.003,3.86-0.724,4.603-0.794 C86.297,38.366,88.122,34.778,85.398,34.804z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow2);
export default __webpack_public_path__ + "static/media/how_2.8804e3f2e4688b4ccc5631ec31f52722.svg";
export { ForwardRef as ReactComponent };